import { styled } from "styled-components";

export const StyledHeader = styled.nav`
	position: fixed;
	width: 100%;
	box-shadow: 0px 4px 4px rgba(71, 73, 75, 0.04);
	background: #ffffff;
	z-index: 10;

	.content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		width: 80%;
		height: 10vh;

		img {
			width: 125px;
		}
		h5 {
			color: #555555;
			font-weight: bold;
		}
	}

	@media screen and (max-width: 480px) {
		display: none;
	}
`;

export const CardWrapper = styled.div`
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #fff;
	overflow: hidden;
`;

export const Card = styled.div`
	width: 90%;
	max-width: 486px;
	max-height: 85vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 20px 30px 30px;
	margin-top: 45px;
	color: #555555;
	background: #ffffff;
	box-shadow: 0px 30px 50px 10px rgba(0, 103, 112, 0.1);
	border-radius: 30px;

	.subtext {
		color: #006770;
		font-weight: 700;
		font-size: 18px;
		margin: 20px 0;
	}

	a {
		color: #006770;
		font-weight: bold;
	}

	& > img,
	img.logo {
		width: 32px;
	}

	@media screen and (max-width: 480px) {
		margin-top: 0 !important;
	}
`;
